export const version = '1.5.4';
//# sourceMappingURL=version.js.map